import {
  Dispatch,
  ReactNode,
  createContext,
  useContext,
  useReducer,
} from "react"
import { initialState, reducer } from "../state/toastReducer"
import { Action, ToastState } from "../types/ToastState"

type Props = {
  children: ReactNode
  passedState?: ToastState
}

const ToastDispatchContext = createContext<Dispatch<Action> | undefined>(
  undefined,
)

const ToastStateContext = createContext(initialState)

const ToastContextProvider = ({ children, passedState }: Props) => {
  const [state, dispatch] = useReducer(reducer, passedState ?? initialState)

  return (
    <ToastStateContext.Provider value={state}>
      <ToastDispatchContext.Provider value={dispatch}>
        {children}
      </ToastDispatchContext.Provider>
    </ToastStateContext.Provider>
  )
}

const useToastDispatch = () => {
  const context = useContext(ToastDispatchContext)
  if (context === undefined) {
    throw new Error(
      "useToastDispatch must be used within an ToastContextProvider",
    )
  }
  return context
}

const useToastState = () => {
  const context = useContext(ToastStateContext)
  if (context === undefined) {
    throw new Error("useToastState must be used within an ToastContextProvider")
  }
  return context
}

export { ToastContextProvider, useToastDispatch, useToastState }
